export interface FieldValidation {
	ruleName: ValidationRuleName;
	controlValue: string;
	condition: boolean;
	message: string;
}

export enum ValidationRuleName {
	DATE_AFTER = 'DATE_AFTER',
	DATE_BEFORE = 'DATE_BEFORE',
	DATE_EQUALS = 'DATE_EQUALS',
	STRING_EQUALS = 'STRING_EQUALS',
	STRING_NOT_EQUALS = 'STRING_NOT_EQUALS',
	STRING_NOT_EQUALS_OR_CONDITION = 'STRING_NOT_EQUALS_OR_CONDITION',
	STRING_NOT_STARTS_WITH_UNDERSCORE = 'STRING_NOT_STARTS_WITH_UNDERSCORE',
	STRING_MATCHES_REGEX = 'STRING_MATCHES_REGEX',
	NUMBER_EQUAL_OR_LESS_THAN = 'NUMBER_EQUAL_OR_LESS_THAN',
	NUMBER_EQUAL_OR_GREATER_THAN = 'NUMBER_EQUAL_OR_GREATER_THAN',
}

export interface FieldValidationList extends Array<FieldValidation> {
	[index: number]: FieldValidation;
}
